import { useFormContext } from 'react-hook-form'
import CheckboxesAll from '@components/form/CheckboxesAll'

const ContextCheckboxes = (props) => {
    const methods = useFormContext()
    return <CheckboxesAll {...props}
        methods={methods}
        allOption={false} />
}

export default ContextCheckboxes